import type { NextPage } from 'next';
import styles from './download.module.scss';
import { DownloadType } from '@/types/footer.types';
import FooterDownloadButtons from './FooterDownloadButtons';

const FooterDownload: NextPage<DownloadType> = ({
  className = '',
  property1 = 'Desktop',
}) => {
  return (
    <div
      className={[styles.download, className].join(' ')}
      data-property1={property1}
    >
      <h2 className={styles.downloadTheHera}>
        Download the Hera Flight mobile app
      </h2>
      <FooterDownloadButtons />
    </div>
  );
};

export default FooterDownload;
